// External modules
import styled from '@emotion/styled';

// Internal modules
import { TEXT_COLOR } from '@/styles';
import { getLinkStateStyles } from '@/components/Common';

const SelectAllHeader = styled.div`
  color: ${TEXT_COLOR};
  font-size: 14px;
  line-height: 1.38;
  line-height: 1.6;
  text-align: left;

  > * {
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const StyledLink = styled.span`
  color: ${({ theme }) => theme.link.default.color};
  line-height: ${({ theme }) => theme.link.default.lineHeight};
  cursor: pointer;
  user-select: none;
  font-size: 14px;
  font-weight: 700;
  display: inline-block;

  ${({ theme }) => getLinkStateStyles(theme)}
`;
export { SelectAllHeader, StyledLink };
